import {
    FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_REQUEST,
    FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_SUCCESS,
    FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_FAILURE,
  } from "./FetchExternalPractitionerAutoCompleteTypes";
  import api from "../../utils/Api";
  
  export const fetchExternalPractitionerAutoCompRequest = () => {
    return {
      type: FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_REQUEST,
    };
  };
  
  export const fetchExternalPractitionerAutoCompSuccess = (practitioner) => {
    return {
      type: FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_SUCCESS,
      payload: practitioner,
    };
  };
  
  export const fetchExternalPractitionerAutoCompFailure = (error) => {
    return {
      type: FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_FAILURE,
      payload: error,
    };
  };
  
  export const fetchExternalPractitionerAutoComp = (practitioner_name, isExternalPractitioner) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "relatedparty/practitioner/autocomplete?practitioner_name="+practitioner_name;
    if(isExternalPractitioner){
      url += "&isExternalPractitioner=" + isExternalPractitioner ;
    }
    return async (dispatch) => {
      dispatch(fetchExternalPractitionerAutoCompRequest);
      try {
        const response = await api.get(url ,
          {
            headers: headers,
          }
        );
  
        const practitioner = response.data.data;
        //console.log("******* practitioner autocomplete - ", practitioner);
        dispatch(fetchExternalPractitionerAutoCompSuccess(practitioner));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchExternalPractitionerAutoCompFailure(errorMsg));
      }
    };
  };
  